// color-roles.ts
export const colorRoleTokens = {
  "color": {
    "bg": {
      "canvas": {
        "value": "#121212",
        "type": "color",
        "filePath": "design-tokens/color-roles.json",
        "isSource": true,
        "original": {
          "value": "{neutral.10}",
          "type": "color"
        },
        "name": "ColorBgCanvas",
        "attributes": {
          "category": "color",
          "type": "bg",
          "item": "canvas"
        },
        "path": [
          "color",
          "bg",
          "canvas"
        ]
      },
      "surface": {
        "value": "#1e1e1e",
        "type": "color",
        "filePath": "design-tokens/color-roles.json",
        "isSource": true,
        "original": {
          "value": "{neutral.20}",
          "type": "color"
        },
        "name": "ColorBgSurface",
        "attributes": {
          "category": "color",
          "type": "bg",
          "item": "surface"
        },
        "path": [
          "color",
          "bg",
          "surface"
        ]
      },
      "surfaceVariant": {
        "value": "#2a2a2a",
        "type": "color",
        "filePath": "design-tokens/color-roles.json",
        "isSource": true,
        "original": {
          "value": "{neutral.30}",
          "type": "color"
        },
        "name": "ColorBgSurfaceVariant",
        "attributes": {
          "category": "color",
          "type": "bg",
          "item": "surfaceVariant"
        },
        "path": [
          "color",
          "bg",
          "surfaceVariant"
        ]
      }
    },
    "text": {
      "primary": {
        "value": "#e0e0e0",
        "type": "color",
        "filePath": "design-tokens/color-roles.json",
        "isSource": true,
        "original": {
          "value": "{neutral.90}",
          "type": "color"
        },
        "name": "ColorTextPrimary",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "primary"
        },
        "path": [
          "color",
          "text",
          "primary"
        ]
      },
      "secondary": {
        "value": "#a0a0a0",
        "type": "color",
        "filePath": "design-tokens/color-roles.json",
        "isSource": true,
        "original": {
          "value": "{neutral.70}",
          "type": "color"
        },
        "name": "ColorTextSecondary",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "secondary"
        },
        "path": [
          "color",
          "text",
          "secondary"
        ]
      },
      "inverse": {
        "value": "#121212",
        "type": "color",
        "filePath": "design-tokens/color-roles.json",
        "isSource": true,
        "original": {
          "value": "{neutral.10}",
          "type": "color"
        },
        "name": "ColorTextInverse",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "inverse"
        },
        "path": [
          "color",
          "text",
          "inverse"
        ]
      }
    }
  },
  "roles": {
    "primary": {
      "value": "#ffc699",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{primary.80}",
        "type": "color"
      },
      "name": "RolesPrimary",
      "attributes": {
        "category": "roles",
        "type": "primary"
      },
      "path": [
        "roles",
        "primary"
      ]
    },
    "onPrimary": {
      "value": "#4a1f00",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{primary.20}",
        "type": "color"
      },
      "name": "RolesOnPrimary",
      "attributes": {
        "category": "roles",
        "type": "onPrimary"
      },
      "path": [
        "roles",
        "onPrimary"
      ]
    },
    "primaryContainer": {
      "value": "#7a3200",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{primary.30}",
        "type": "color"
      },
      "name": "RolesPrimaryContainer",
      "attributes": {
        "category": "roles",
        "type": "primaryContainer"
      },
      "path": [
        "roles",
        "primaryContainer"
      ]
    },
    "onPrimaryContainer": {
      "value": "#ffe2cc",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{primary.90}",
        "type": "color"
      },
      "name": "RolesOnPrimaryContainer",
      "attributes": {
        "category": "roles",
        "type": "onPrimaryContainer"
      },
      "path": [
        "roles",
        "onPrimaryContainer"
      ]
    },
    "secondary": {
      "value": "#c5bfe1",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{secondary.80}",
        "type": "color"
      },
      "name": "RolesSecondary",
      "attributes": {
        "category": "roles",
        "type": "secondary"
      },
      "path": [
        "roles",
        "secondary"
      ]
    },
    "onSecondary": {
      "value": "#2a2533",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{secondary.20}",
        "type": "color"
      },
      "name": "RolesOnSecondary",
      "attributes": {
        "category": "roles",
        "type": "onSecondary"
      },
      "path": [
        "roles",
        "onSecondary"
      ]
    },
    "secondaryContainer": {
      "value": "#3f3a4d",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{secondary.30}",
        "type": "color"
      },
      "name": "RolesSecondaryContainer",
      "attributes": {
        "category": "roles",
        "type": "secondaryContainer"
      },
      "path": [
        "roles",
        "secondaryContainer"
      ]
    },
    "onSecondaryContainer": {
      "value": "#e2dbf9",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{secondary.90}",
        "type": "color"
      },
      "name": "RolesOnSecondaryContainer",
      "attributes": {
        "category": "roles",
        "type": "onSecondaryContainer"
      },
      "path": [
        "roles",
        "onSecondaryContainer"
      ]
    },
    "tertiary": {
      "value": "#8adbfd",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{tertiary.80}",
        "type": "color"
      },
      "name": "RolesTertiary",
      "attributes": {
        "category": "roles",
        "type": "tertiary"
      },
      "path": [
        "roles",
        "tertiary"
      ]
    },
    "onTertiary": {
      "value": "#003547",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{tertiary.20}",
        "type": "color"
      },
      "name": "RolesOnTertiary",
      "attributes": {
        "category": "roles",
        "type": "onTertiary"
      },
      "path": [
        "roles",
        "onTertiary"
      ]
    },
    "tertiaryContainer": {
      "value": "#004d66",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{tertiary.30}",
        "type": "color"
      },
      "name": "RolesTertiaryContainer",
      "attributes": {
        "category": "roles",
        "type": "tertiaryContainer"
      },
      "path": [
        "roles",
        "tertiaryContainer"
      ]
    },
    "onTertiaryContainer": {
      "value": "#c7eeff",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{tertiary.90}",
        "type": "color"
      },
      "name": "RolesOnTertiaryContainer",
      "attributes": {
        "category": "roles",
        "type": "onTertiaryContainer"
      },
      "path": [
        "roles",
        "onTertiaryContainer"
      ]
    },
    "error": {
      "value": "#ffb4ab",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{error.80}",
        "type": "color"
      },
      "name": "RolesError",
      "attributes": {
        "category": "roles",
        "type": "error"
      },
      "path": [
        "roles",
        "error"
      ]
    },
    "onError": {
      "value": "#690005",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{error.20}",
        "type": "color"
      },
      "name": "RolesOnError",
      "attributes": {
        "category": "roles",
        "type": "onError"
      },
      "path": [
        "roles",
        "onError"
      ]
    },
    "errorContainer": {
      "value": "#93000a",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{error.30}",
        "type": "color"
      },
      "name": "RolesErrorContainer",
      "attributes": {
        "category": "roles",
        "type": "errorContainer"
      },
      "path": [
        "roles",
        "errorContainer"
      ]
    },
    "onErrorContainer": {
      "value": "#ffdad6",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{error.90}",
        "type": "color"
      },
      "name": "RolesOnErrorContainer",
      "attributes": {
        "category": "roles",
        "type": "onErrorContainer"
      },
      "path": [
        "roles",
        "onErrorContainer"
      ]
    },
    "warning": {
      "value": "#ffc94d",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{warning.80}",
        "type": "color"
      },
      "name": "RolesWarning",
      "attributes": {
        "category": "roles",
        "type": "warning"
      },
      "path": [
        "roles",
        "warning"
      ]
    },
    "onWarning": {
      "value": "#4a2f00",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{warning.20}",
        "type": "color"
      },
      "name": "RolesOnWarning",
      "attributes": {
        "category": "roles",
        "type": "onWarning"
      },
      "path": [
        "roles",
        "onWarning"
      ]
    },
    "warningContainer": {
      "value": "#6a4500",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{warning.30}",
        "type": "color"
      },
      "name": "RolesWarningContainer",
      "attributes": {
        "category": "roles",
        "type": "warningContainer"
      },
      "path": [
        "roles",
        "warningContainer"
      ]
    },
    "onWarningContainer": {
      "value": "#ffe7b3",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{warning.90}",
        "type": "color"
      },
      "name": "RolesOnWarningContainer",
      "attributes": {
        "category": "roles",
        "type": "onWarningContainer"
      },
      "path": [
        "roles",
        "onWarningContainer"
      ]
    },
    "success": {
      "value": "#7fdc96",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{success.80}",
        "type": "color"
      },
      "name": "RolesSuccess",
      "attributes": {
        "category": "roles",
        "type": "success"
      },
      "path": [
        "roles",
        "success"
      ]
    },
    "onSuccess": {
      "value": "#00391a",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{success.20}",
        "type": "color"
      },
      "name": "RolesOnSuccess",
      "attributes": {
        "category": "roles",
        "type": "onSuccess"
      },
      "path": [
        "roles",
        "onSuccess"
      ]
    },
    "successContainer": {
      "value": "#005227",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{success.30}",
        "type": "color"
      },
      "name": "RolesSuccessContainer",
      "attributes": {
        "category": "roles",
        "type": "successContainer"
      },
      "path": [
        "roles",
        "successContainer"
      ]
    },
    "onSuccessContainer": {
      "value": "#b8f1c3",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{success.90}",
        "type": "color"
      },
      "name": "RolesOnSuccessContainer",
      "attributes": {
        "category": "roles",
        "type": "onSuccessContainer"
      },
      "path": [
        "roles",
        "onSuccessContainer"
      ]
    }
  },
  "outline": {
    "outline": {
      "value": "#5c5c5c",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.50}",
        "type": "color"
      },
      "name": "OutlineOutline",
      "attributes": {
        "category": "outline",
        "type": "outline"
      },
      "path": [
        "outline",
        "outline"
      ]
    },
    "outlineVariant": {
      "value": "#2a2a2a",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.30}",
        "type": "color"
      },
      "name": "OutlineOutlineVariant",
      "attributes": {
        "category": "outline",
        "type": "outlineVariant"
      },
      "path": [
        "outline",
        "outlineVariant"
      ]
    }
  },
  "surface": {
    "surfaceDim": {
      "value": "#121212",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.10}",
        "type": "color"
      },
      "name": "SurfaceSurfaceDim",
      "attributes": {
        "category": "surface",
        "type": "surfaceDim"
      },
      "path": [
        "surface",
        "surfaceDim"
      ]
    },
    "surface": {
      "value": "#1e1e1e",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.20}",
        "type": "color"
      },
      "name": "SurfaceSurface",
      "attributes": {
        "category": "surface",
        "type": "surface"
      },
      "path": [
        "surface",
        "surface"
      ]
    },
    "surfaceBright": {
      "value": "#2a2a2a",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.30}",
        "type": "color"
      },
      "name": "SurfaceSurfaceBright",
      "attributes": {
        "category": "surface",
        "type": "surfaceBright"
      },
      "path": [
        "surface",
        "surfaceBright"
      ]
    },
    "surfaceContainerLow": {
      "value": "#1e1e1e",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.20}",
        "type": "color"
      },
      "name": "SurfaceSurfaceContainerLow",
      "attributes": {
        "category": "surface",
        "type": "surfaceContainerLow"
      },
      "path": [
        "surface",
        "surfaceContainerLow"
      ]
    },
    "surfaceContainer": {
      "value": "#242424",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.25}",
        "type": "color"
      },
      "name": "SurfaceSurfaceContainer",
      "attributes": {
        "category": "surface",
        "type": "surfaceContainer"
      },
      "path": [
        "surface",
        "surfaceContainer"
      ]
    },
    "surfaceContainerHigh": {
      "value": "#2a2a2a",
      "type": "color",
      "filePath": "design-tokens/color-roles.json",
      "isSource": true,
      "original": {
        "value": "{neutral.30}",
        "type": "color"
      },
      "name": "SurfaceSurfaceContainerHigh",
      "attributes": {
        "category": "surface",
        "type": "surfaceContainerHigh"
      },
      "path": [
        "surface",
        "surfaceContainerHigh"
      ]
    }
  }
} as const;

export type ColorRoleTokens = typeof colorRoleTokens;
